import TYPES                    from "@/core/services/Changelogs/types";
import type { FieldDescriptor } from "@/core/misc/decorators/Title_ru_RU";

type AdditionalFieldsConfig = Record<string, FieldDescriptor>;

/**
 * Хелпер для создания дескриптора поля
 */
export function field(title: string, type: typeof TYPES[keyof typeof TYPES], resolver?: CustomResolver): FieldDescriptor {
	return { title, type, resolver };
}

/**
 * Декоратор класса для добавления дескрипторов полей, которых нет в модели
 * @param additionalFields - объект с дополнительными дескрипторами полей
 */
function AdditionalFieldDescriptors(additionalFields: AdditionalFieldsConfig) {
	return function <T extends { new(...args: any[]): {} }>(constructor: T) {
		if (!constructor._fieldDescriptors) {
			constructor._fieldDescriptors = {};
		}

		// Добавляем дополнительные дескрипторы к существующим
		Object.entries(additionalFields).forEach(([fieldName, descriptor]) => {
			// Не перезаписываем существующие дескрипторы
			if (!constructor._fieldDescriptors[fieldName]) {
				constructor._fieldDescriptors[fieldName] = descriptor;
			}
		});

		return constructor;
	};
}

export default AdditionalFieldDescriptors;
